import { render, staticRenderFns } from "./ADeletedChip.vue?vue&type=template&id=5745f5fa&scoped=true&"
import script from "./ADeletedChip.vue?vue&type=script&lang=ts&"
export * from "./ADeletedChip.vue?vue&type=script&lang=ts&"
import style0 from "./ADeletedChip.vue?vue&type=style&index=0&id=5745f5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745f5fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VTooltip})
